/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The browser's IANA zone, re-read when the tab comes back: a laptop that crossed
 * a border while asleep reports the new zone without a reload.
 */
import { useEffect, useState } from "react";

const readZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export function useBrowserZone(): string {
  const [zone, setZone] = useState(readZone);

  useEffect(() => {
    const refresh = () => setZone(readZone());
    const onVisibility = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", refresh);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return zone;
}
